import "./LocationBloodDrawInformationDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import ChipComponent from "../../../../../shared/components/chip/ChipComponent";
import {CommonService} from "../../../../../shared/services";

interface LocationBloodDrawInformationDetailsViewComponentProps {
    locationInformation: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const LocationBloodDrawInformationDetailsViewComponent = (props: LocationBloodDrawInformationDetailsViewComponentProps) => {
    const {locationInformation, onEditModeOpen, canEdit} = props;
    return (
        <div className={'location-blood-draw-information-details-view-component details-tab-data-content'}>
            {locationInformation && <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Billing Details</div>
                    {
                        canEdit && <div className={'edit-action-button'}>
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Phleb Name"}> {locationInformation?.bloodDrawInformation?.phlebotomistDetails?.name ? CommonService.capitalizeFirstLetterOfEachWord(locationInformation?.bloodDrawInformation?.phlebotomistDetails?.name) : 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Draw"}> {locationInformation?.bloodDrawInformation?.phlebotomistDetails?.draw?.title || 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Phleb Address"}> {locationInformation?.bloodDrawInformation?.phlebotomistDetails?.address || 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Phleb State"}> {locationInformation?.bloodDrawInformation?.phlebotomistDetails?.state || 'NA'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Phleb Contact Number"}> {CommonService.getMaskedMobileNumber(locationInformation?.bloodDrawInformation?.phlebotomistDetails?.contactNumber) || 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Phleb Contract Needed"}> {locationInformation?.bloodDrawInformation?.phlebotomistDetails?.contractNeeded?.title || 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Phleb ZIP Code"}> {locationInformation?.bloodDrawInformation?.phlebotomistDetails?.zipcode || 'NA'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Phleb City"}> {locationInformation?.bloodDrawInformation?.phlebotomistDetails?.city || 'NA'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                    {
                        locationInformation?.bloodDrawInformation?.phlebotomistDetails?.pickUpDaysAndTimes?.length > 0 && <>
                            <div className="horizontal-line"/>
                            <div className="view-and-edit-title mrg-bottom-20">Pickup Days And Time</div>
                        </>
                    }
                    {
                        locationInformation?.bloodDrawInformation?.phlebotomistDetails?.pickUpDaysAndTimes?.length > 0 && <>
                            <div className={'display-flex-with-column-gap'}>
                                {
                                    locationInformation?.bloodDrawInformation?.phlebotomistDetails?.pickUpDaysAndTimes?.map((dayAndTime: any, index: number) => {
                                        return (
                                            <div key={index}>
                                                <ChipComponent
                                                    label={`${CommonService.capitalizeFirstLetter(dayAndTime.day)} | ${dayAndTime.time}`}
                                                />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                </div>
            </>
            }
        </div>
    );

};

export default LocationBloodDrawInformationDetailsViewComponent;
